<template>
    <div :class="inputClass">
        <textarea
            v-model="inputValue"
            v-bind="attrs"
            :placeholder="placeholder"
            :autofocus="hasAutofocus"
            :required="isRequired"
            :type="type"
            :disabled="isDisabled"
            @input="change($event)"
        ></textarea>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number], default: undefined },
            placeholder: { type: String, default: undefined },
            type: { type: String, default: 'text' },
        },

        data() {
            return {
                inputValue: this.realInputValue,
            }
        },

        computed: {
            inputClass() {
                return {
                    'form-input-text': true,
                    'form-input-text--is-invalid': this.isInvalid,
                    'form-input-text--is-disabled': this.isDisabled,
                }
            },
        },

        watch: {
            value() {
                this.inputValue = this.value
            },
        },
    }
</script>
